import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import { CustomIconButton } from "../CustomToggleButton";
import { RichTooltipPopover } from "../../RichTooltipPopover";
import SubmissionStackedGraph from "../stackedGraph/SubmissionStackedGraph";
import { useGetTheme } from "../../../../hooks";

const ChatReport = ({ data, courseAssignments, tooltip }) => {
  const theme = useGetTheme();
  const [studentView, setStudentView] = useState(true);

  const transformDataToStudentsView = (data) => {
    const studentsViewData = {};
    Object.keys(data).forEach((taskId) => {
      studentsViewData[taskId] = {
        chatPercentage: data[taskId].studentsEngPercentage
      };
    });
    return studentsViewData;
  };

  const renderHeader = () => (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "60px",
        flexFlow: "row nowrap",
        alignItems: "center",
        borderBottom: `1px solid ${theme.palette.border.secondary}`
      }}>
      <Typography variant="subtitle1">Academic Coach Usage</Typography>
      <RichTooltipPopover
        name="Average time spent on assignments"
        body={tooltip}
      />
    </Box>
  );

  const renderViewToggle = () => (
    <Box sx={{ paddingTop: "16px" }}>
      <CustomIconButton
        icon={InsertChartIcon}
        label="Student view"
        isActive={studentView}
        onClick={() => setStudentView(true)}
      />
      <CustomIconButton
        icon={InsertChartIcon}
        label="Chat view"
        isActive={!studentView}
        onClick={() => setStudentView(false)}
      />
    </Box>
  );

  const renderChart = () => (
    <Box sx={{ height: "80%" }}>
      {studentView ? (
        <SubmissionStackedGraph
          type="coachUsageStudents"
          data={transformDataToStudentsView(data)}
          courseAssignments={courseAssignments}
        />
      ) : (
        <SubmissionStackedGraph
          type="coachUsageChats"
          data={data}
          courseAssignments={courseAssignments}
        />
      )}
    </Box>
  );

  return (
    <Box
      sx={{
        paddingInline: "24px",
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.border.secondary}`,
        height: "500px",
        borderRadius: "5px"
      }}>
      {renderHeader()}
      <Box
        sx={{
          display: "flex",
          flexFlow: "column nowrap",
          width: "inherit",
          height: "100%"
        }}>
        {renderViewToggle()}
        <Box>{renderChart()}</Box>
      </Box>
    </Box>
  );
};

export default ChatReport;
